export enum SMTPTypes {
    Receipt = 1,
            Alert =2,
            IdentityManagement=3
}
